import '@updater-components/icon';
import '@updater-components/tooltip';
import template from './card.html';
import { IS_TOUCH_DEVICE } from '../../../../constants';
import './card.global.css';

class UpdateAccountCardController {
  constructor(UyaTextHelper) {
    'ngInject';
    Object.assign(this, { UyaTextHelper });
  }

  get buttonText() {
    return this.hasItems ? '+ add more' : '+';
  }

  get buttonAnalyticsEvent() {
    return this.hasItems
      ? 'Clicked Add More Accounts CTA'
      : 'Clicked Add Account CTA';
  }

  get enableTooltip() {
    return !IS_TOUCH_DEVICE;
  }

  get hasItems() {
    return !!(this.items || []).length;
  }

  get isComingSoon() {
    return this.category.comingSoon;
  }

  iconTooltip(state) {
    return this.UyaTextHelper.iconText(state);
  }

  popoverText(item, date) {
    return this.UyaTextHelper.plainText(item, date);
  }
}

export const UpdateAccountCardComponent = {
  template,
  controller: UpdateAccountCardController,
  bindings: {
    category: '<',
    items: '<',
    cancel: '&',
    searchSref: '@',
    moveDate: '<',
  },
};
